import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CategoryInRoomCredentialsEffects } from './category-in-room-credentials.effects';
import { categoryInRoomCredentialsReducer } from './category-in-room-credentials.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('categoryInRoomCredentials', categoryInRoomCredentialsReducer),
    EffectsModule.forFeature([CategoryInRoomCredentialsEffects]),
  ],
  providers: [],
})
export class CategoryInRoomCredentialsStoreModule {}
